import * as React from 'react';
import { useBeforeunload } from 'react-beforeunload';

import { LandingBlock } from '../../components/LandingBlock';
import { ContentWrapper } from '../../components/ContentWrapper';
import { BlockHeader } from '../../components/BlockHeader';
import * as styles from './SuburbanFinCalculator.css';
import { TSuburbanCalculatorDataStringify } from '../../types/suburban';
import { CalculatorComponent } from '../../components/CalculatorComponent';

interface ISuburbanFinCalculator {
  config: TSuburbanCalculatorDataStringify;
}

export const FIN_CALCULATOR_STATE_STORAGE_KEY = 'calculatorState';

/* istanbul ignore next */
export const removeFinCalcStateFromLocalStorage = () => {
  localStorage.removeItem(FIN_CALCULATOR_STATE_STORAGE_KEY);
};

export const SuburbanFinCalculator: React.FC<ISuburbanFinCalculator> = ({ config }) => {
  useBeforeunload(removeFinCalcStateFromLocalStorage);

  return (
    <div className={styles['fin-container']}>
      <LandingBlock>
        <ContentWrapper>
          <BlockHeader>Рассчитайте условия ипотеки</BlockHeader>
          <CalculatorComponent {...config} />
        </ContentWrapper>
      </LandingBlock>
    </div>
  );
};
